import { i18n } from 'services';

export const isNegativeNumber = (value: string | number) => {
  const currentValue = typeof value === 'string' ? Number(value) : value;
  return currentValue < 0 ? i18n.t('formValidationErrors.isNegativeNumber') : undefined;
};
